import React, { useEffect, useState } from 'react';
import { getFeedbackUrl } from 'ts/config/ConfigService';
import { TextLink } from '@origin-digital/ods-core';
import { getLiveChatStatus, StatusType } from 'ts/services/liveChatService';

export const ChatLink: React.FC = ({ children }): JSX.Element => {
  const [status, setStatus] = useState<StatusType>(StatusType.UNAVAILABLE);
  const onLiveChatButtonClick = (event: React.MouseEvent) => {
    event.preventDefault();
    window.Intercom('show');
  };

  useEffect(() => {
    const statusOnLoad = getLiveChatStatus();
    setStatus(statusOnLoad);
  }, []);

  return (
    <ChatLinkView status={status} onLiveChatButtonClick={onLiveChatButtonClick}>
      {children}
    </ChatLinkView>
  );
};

interface ChatLinkViewProps {
  status: StatusType;
  onLiveChatButtonClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

export const ChatLinkView: React.FC<ChatLinkViewProps> = ({
  status,
  onLiveChatButtonClick,
  children = 'contact us',
}) =>
  status === StatusType.AVAILABLE ? (
    <TextLink data-id="contact-us-link-livechat" href="#" onClick={onLiveChatButtonClick}>
      {children}
    </TextLink>
  ) : (
    <TextLink data-id="contact-us-link-formstack" href={getFeedbackUrl()}>
      {children}
    </TextLink>
  );
